import { Brand_Enum, User_Role_Enum } from '@kheops/graphql';
import { useMemo } from 'react';

type BrandToWordingMap = {
  [index in Brand_Enum]?: string;
} & {
  default: string;
}

export const ROLE_WORDING_MAP: Record<User_Role_Enum, string | BrandToWordingMap > = {
  [User_Role_Enum.BuyerManager]: 'company:buyer_manager',
  [User_Role_Enum.BuyerOwner]: {
    [Brand_Enum.HyperU]: 'company:buyer_owner_partner',
    [Brand_Enum.SuperU]: 'company:buyer_owner_partner',
    [Brand_Enum.UExpress]: 'company:buyer_owner_partner',
    [Brand_Enum.Utile]: 'company:buyer_owner_partner',
    [Brand_Enum.ELeclerc]: 'company:buyer_owner_participant',
    [Brand_Enum.ELeclercExpress]: 'company:buyer_owner_participant',
    [Brand_Enum.IntermarcheHyper]: 'company:buyer_owner_participant',
    [Brand_Enum.IntermarcheSuper]: 'company:buyer_owner_participant',
    [Brand_Enum.IntermarcheExpress]: 'company:buyer_owner_participant',
    [Brand_Enum.IntermarcheContact]: 'company:buyer_owner_participant',
    default: 'company:buyer_owner',
  },
  [User_Role_Enum.BuyerDirector]: 'company:buyer_director',
  [User_Role_Enum.BuyerFinance]: 'company:buyer_finance',
  [User_Role_Enum.SupplierOwner]: 'company:supplier_owner',
  [User_Role_Enum.SupplierSalesAdmin]: 'company:supplier_sales_admin',
  [User_Role_Enum.SupplierSalesRep]: 'company:supplier_sales_rep',
  [User_Role_Enum.CompanyAdmin]: 'company:admin',
  [User_Role_Enum.StaffAdmin]: '',
};

export function useCompanyTeamRoleWording(companyBrand?: Brand_Enum): Record<User_Role_Enum, string> {
  return useMemo(() => {
    return Object.entries(ROLE_WORDING_MAP).reduce((acc, [role, wording]) => {
      if (typeof wording === 'string') {
        acc[role as User_Role_Enum] = wording;
      } else {
        acc[role as User_Role_Enum] = (companyBrand && wording[companyBrand]) || wording.default;
      }

      return acc;
    }, {} as Record<User_Role_Enum, string>);
  }, [companyBrand]);
}
